import {Component, OnInit} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from "@angular/router";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {OverlayService} from "../../overlay/overlay.service";
import {ProjectAreaService} from "../../services/project-area.service";
import {ProjectArea} from "../../enums/project-area";

@UntilDestroy()
@Component({
  selector: 'brt-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  narrowMarginTop = false;

  theme: "white" | "game" = "white"

  constructor(
    private overlayService: OverlayService,
    private router: Router,
    private projectAreaService: ProjectAreaService
  ) {
  }

  currentYear: number = new Date().getFullYear();

  ngOnInit() {

    // Trigger Route dependent Events
    this.router.events
      .pipe(untilDestroyed(this))
      .subscribe((event) => {
        if (event instanceof NavigationStart) {

        } else if (event instanceof NavigationEnd) {
          this.narrowMarginTop = this.router.url === "/berufe/anforderungen";
        }
      });

    this.projectAreaService.onAreaUpdated().pipe(untilDestroyed(this)).subscribe((newValue) => {
      if(newValue === ProjectArea.GAME) this.theme = "game";
      else this.theme = "white";
    })
  }

    loadPrivacyWidget($event: MouseEvent) {
      $event.preventDefault();
      // @ts-ignore
      editViaLink = true;
      if (document.getElementById('cookie-banner')) {
        // @ts-ignore
        document.getElementById('cookie-banner').remove();
        // @ts-ignore
        document.getElementById('cookie-style').remove();
      }
      if (!document.getElementById('cookie-backdrop')) {
        // @ts-ignore
          createBackdrop();
        }
      if (!document.getElementById('cookie-settings')) {
        // @ts-ignore
        editSettings();
    }

  }

}
